import React from 'react'
import { classNames } from '@react-spectrum/utils'
import { Container } from './styledComponents'

interface UnderlayProps {
  isOpen?: boolean
}

export function Underlay({ isOpen }: UnderlayProps) {
  return (
    <Container
      className={classNames({}, 'spectrum-Underlay', { 'is-open': isOpen })}
    />
  )
}
